import React from 'react'
import _ from 'lodash'
import classNames from 'classnames'

import {ItineraryTitleButtons} from '../itinerary/itinerarytitlebuttons.component'

export class MobileHeader extends React.Component {
    render() {
        return (
            <div id="mobile-header" className="mobile-planner">
                <a id="show-menu" className="logo" href="/trips"><img src="/assets/img/logos/luna_horiz.svg"/></a>
                <ItineraryTitleButtons {...this.props}/>
            </div>
        )
    }
}